<template>
    <div class="inner-wrapper">
        <div class="inner-wrapper-md">
            <div class="row">
                <div class="col-12">
                    <form @submit.prevent="sendPassword">
                        <fieldset>
                            <legend class="page-title" ref="pageHeading" tabindex="-1">
                                Reset your password
                            </legend>
                            <p class="body">
                                Enter your email address and we will send you a link to reset your
                                password.
                            </p>
                            <AlertMessages />
                            <div class="form-group">
                                <div class="field-wrapper" v-flyout>
                                    <input type="email"
                                           class="text-field-3"
                                           id="email"
                                           autocomplete="email"
                                           aria-label="Email address"
                                           aria-required="true"
                                           :aria-invalid="$v.Email.$error"
                                           aria-errormessage="errorEmail"
                                           placeholder=""
                                           v-model="Email"
                                           :class="{ 'is-invalid': $v.Email.$error }" />
                                    <div class="field-placeholder" v-animate>
                                        <span class="asterisk">Email address</span>
                                    </div>
                                </div>

                                <div id="errorEmail" v-if="$v.Email.$error" class="feedback">
                                    <span v-if="!$v.Email.required">This field is required</span>
                                    <span v-if="!$v.Email.email && $v.Email.$dirty">Incorrect email format</span>
                                </div>
                            </div>
                            <div class="form-row cta-group flex-column flex-column-md-reverse flex-md-row">
                                <button class="cta-white-169">
                                    Send email<span class="angle-right-white"></span>
                                </button>
                                <router-link role="navigation" class="back-link" :to="{ name: 'signin' }">
                                    <span class="angle-left-green"></span>
                                    Back to sign in
                                </router-link>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { required, email } from "vuelidate/lib/validators";
    import { mapActions, mapState } from "vuex";
    import { publicRouter } from "../router";
    import AlertMessages from "../components/alert-messages";
    import { RESETPASSWORD } from "../store/mutation-types";
    export default {
        name: "PasswordForgot",

        //props: ["id"] ,
        //{
        //   id: {
        //     type: String,
        //    // default: 0,
        //   },
        // },
        components: { AlertMessages },
        // data() {
        //   return {
        //     email: "",
        //     // submitted: false,
        //     message: ""
        //   };
        // },
        validations: {
            Email: {
                required,
                email
            }
        },
        created() {

        },
        computed: {
            ...mapState("account", ["status"]),
            Email: {
                get() {
                    return this.status.Email;
                },
                set(val) {
                    this.$store.commit(`account/${RESETPASSWORD}`, { Email: val });
                }
            }
        },
        methods: {
            ...mapActions("account", ["forgotPassword"]),
            ...mapActions("alert", ["clear"]),
            async sendPassword() {
                this.clear();
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                let result = await this.forgotPassword({ username: this.Email });
                if (!this.hasError && result)
                    publicRouter.push({ name: "password-reset", query: { id: "2" } });
            }
        },
        mounted() {
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    this.$refs.pageHeading?.focus();
                });
            });
        }
    };
</script>

<style lang="scss" scoped></style>
